import Loadable from '../../components/loadable';

const ManageMfaModal = Loadable({
  loader: () => import('../../components/mfa/manage_mfa_modal'),
  type: 'modal',
});

angular.module('shared').value('ManageMfaModal', ManageMfaModal);
